/* LOTE COR-2 — paleta oficial do funil, do claro ao escuro (só CIANO/MARINHO
   do logo + tokens de status que já existem). Importar `CORES_ETAPA` sempre
   que uma UI pintar barras POR ETAPA do funil. Fechado/Perdido reusam os
   tokens `ok` / `bad` do tailwind.config (verde/vermelho) — sem hex novo. */
export const CORES_ETAPA = {
  "Prospecção":   "rgba(0,138,176,0.40)",
  "Qualificação": "rgba(0,138,176,0.70)",
  "Testes":       "#008AB0",
  "Proposta":     "rgba(0,62,98,0.70)",
  "Negociação":   "#003E62",
  "Fechado":      "#0F7A4B", // = tw.ok.DEFAULT (verde de status)
  "Perdido":      "#B42318", // = tw.bad.DEFAULT (vermelho de status)
};

export function corEtapa(stage){
  return CORES_ETAPA[stage] || "#008AB0";
}
